/**
 * Event Countdown Timer
 * Updates event countdown in real-time and manages add to cart functionality
 */
class EventCountdown {
  constructor() {
    this.banners = document.querySelectorAll('.event-status-banner');
    this.countdownInterval = null;
    this.init();
  }

  init() {
    if (this.banners.length === 0) return;
    
    this.startCountdown();
    this.updateAddToCartButtons();
  }

  startCountdown() {
    // Update countdown every minute
    this.countdownInterval = setInterval(() => {
      this.banners.forEach(banner => {
        this.updateBanner(banner);
      });
    }, 60000); // Update every minute

    // Initial update
    this.banners.forEach(banner => {
      this.updateBanner(banner);
    });
  }

  updateBanner(banner) {
    // Get dates from data attributes (these are already formatted by Liquid)
    const startDateStr = banner.dataset.startDate; // Format: YYYY-MM-DD
    const endDateStr = banner.dataset.endDate;     // Format: YYYY-MM-DD
    const endTime = banner.dataset.endTime;        // Format: HH:MM
    
    // Get current date in YYYY-MM-DD format (same as Liquid 'now' | date: '%Y-%m-%d')
    const now = new Date();
    const currentDateStr = now.getFullYear() + '-' + 
                          String(now.getMonth() + 1).padStart(2, '0') + '-' + 
                          String(now.getDate()).padStart(2, '0');
    
    let eventStatus, message, canAddToCart, daysRemaining;
    
    // Use EXACTLY the same logic as Liquid template
    if (currentDateStr < startDateStr) {
      // Event hasn't started yet (same as Liquid: current_date < start_date_str)
      eventStatus = 'upcoming';
      const startDate = new Date(startDateStr + 'T00:00:00');
      const currentDate = new Date(currentDateStr + 'T00:00:00');
      daysRemaining = Math.ceil((startDate - currentDate) / (1000 * 60 * 60 * 24));
      message = `Event starts in ${daysRemaining} days`;
      canAddToCart = false;
    } else if (currentDateStr == endDateStr) {
      // Event ends today (same as Liquid: current_date == end_date_str)
      eventStatus = 'active';
      daysRemaining = 0;
      message = `Event ends today at ${endTime}`;
      canAddToCart = true;
    } else if (currentDateStr > endDateStr) {
      // Event has ended (same as Liquid: current_date > end_date_str)
      eventStatus = 'ended';
      daysRemaining = 0;
      message = 'Event has ended';
      canAddToCart = false;
    } else {
      // Event is active (same as Liquid: else)
      eventStatus = 'active';
      const endDate = new Date(endDateStr + 'T23:59:59');
      const currentDate = new Date(currentDateStr + 'T00:00:00');
      daysRemaining = Math.floor((endDate - currentDate) / (1000 * 60 * 60 * 24));
      message = `Event ends in ${daysRemaining} days`;
      canAddToCart = true;
    }

    // Update banner content
    this.updateBannerContent(banner, eventStatus, message, canAddToCart);
    
    // Update data attributes
    banner.dataset.eventStatus = eventStatus;
    banner.dataset.canAddToCart = canAddToCart;
    banner.dataset.daysRemaining = daysRemaining;

    // Update add to cart buttons
    this.updateAddToCartButtons();
  }

  updateBannerContent(banner, eventStatus, message, canAddToCart) {
    const messageElement = banner.querySelector('.event-status__message');
    const iconElement = banner.querySelector('.event-status__icon');
    
    if (messageElement) {
      messageElement.textContent = message;
    }
    
    if (iconElement) {
      let icon;
      switch (eventStatus) {
        case 'upcoming':
          icon = '⏰';
          break;
        case 'active':
          icon = '🎉';
          break;
        case 'ended':
          icon = '❌';
          break;
      }
      iconElement.textContent = icon;
    }

    // Update CSS classes
    banner.className = `event-status-banner event-status--${eventStatus}`;
  }

  updateAddToCartButtons() {
    const addToCartButtons = document.querySelectorAll('.product-form__submit');
    
    addToCartButtons.forEach(button => {
      const banner = this.getClosestBanner(button);
      if (banner) {
        const canAddToCart = banner.dataset.canAddToCart === 'true';
        const eventStatus = banner.dataset.eventStatus;
        
        if (!canAddToCart) {
          button.disabled = true;
          button.classList.add('button--disabled');
          
          // Update button text
          const buttonText = button.querySelector('span');
          if (buttonText) {
            switch (eventStatus) {
              case 'upcoming':
                buttonText.textContent = 'Event Not Started';
                break;
              case 'ended':
                buttonText.textContent = 'Event Ended';
                break;
              default:
                buttonText.textContent = 'Cannot Add to Cart';
            }
          }
        } else {
          button.disabled = false;
          button.classList.remove('button--disabled');
          
          // Restore original button text
          const buttonText = button.querySelector('span');
          if (buttonText) {
            buttonText.textContent = 'Add to cart';
          }
        }
      }
    });
  }

  getClosestBanner(element) {
    // Find the closest event status banner
    let currentElement = element;
    while (currentElement && !currentElement.classList.contains('event-status-banner')) {
      currentElement = currentElement.parentElement;
    }
    return currentElement;
  }

  destroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new EventCountdown();
});

// Initialize for dynamic content (Shopify sections)
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.event-status-banner')) {
    new EventCountdown();
  }
});

// Cleanup when section is unloaded
document.addEventListener('shopify:section:unload', (event) => {
  const countdown = event.target.querySelector('.event-countdown');
  if (countdown && countdown.instance) {
    countdown.instance.destroy();
  }
});
